module.exports = __webpack_public_path__ + "img/16.1a555d7a.png";